import React from 'react';
import { createUseStyles } from 'react-jss';
import { layoutDefaults } from '../../utils/layout-defaults';

function ItemDescription({ item, children }) {
  const classes = useStyles();

  return (
    item.description && (
      <div className={classes.container}>
        {item.description}
        {children}
      </div>
    )
  );
}

const useStyles = createUseStyles({
  container: {
    // fontSize: layoutDefaults.fontSize,
    fontWeight: 'lighter',
    opacity: layoutDefaults.opacity,
    marginTop: layoutDefaults.smallerVerticalMargin,
  },
});

export { ItemDescription };
